import type { DrawerConfig } from '@/features/drawer/types/DrawerConfig';
import { BeneficiaryDrawerConfig } from '@/features/drawer/components/BeneficiaryDrawer/config';
import { ClaimSetControlDrawerConfig } from '@/features/drawer/components/ClaimSetControlDrawer/config';
import { ContactsDrawerConfig } from '@/features/drawer/components/ContactsDrawer/config';
import { DocumentsDrawerConfig } from '@/features/drawer/components/DocumentsDrawer/config';
import { InsuredDrawerConfig } from '@/features/drawer/components/InsuredDrawer/config';
import { MilestonesDrawerConfig } from '@/features/drawer/components/MilestonesDrawer/config';
import { NotesDrawerConfig } from '@/features/drawer/components/NotesDrawer/config';
import { PartiesDrawerConfig } from '@/features/drawer/components/PartiesDrawer/config';
import { PartyAddressesDrawerConfig } from '@/features/drawer/components/PartyAddressesDrawer/config';
import { PartyControlDrawerConfig } from '@/features/drawer/components/PartyControlDrawer/config';
import { PartyPaymentInformationDrawerConfig } from '@/features/drawer/components/PartyPaymentInformation/config';
import { PolicyMatchingDrawerConfig } from '@/features/drawer/components/PolicyMatchingDrawer/config';
import { ProducerDrawerConfig } from '@/features/drawer/components/ProducerDrawer/config';
import { RecentActivityDrawerConfig } from '@/features/drawer/components/RecentActivityDrawer/config';
import { TasksDrawerConfig } from '@/features/drawer/components/TasksDrawer/config';
import { Drawers } from '@/features/drawer/enums/Drawers';
import { AdminUserControlDrawerConfig } from '../components/AdminUsersControlDrawer/config';
import { BenefitCalculationDrawerConfig } from '../components/BenefitCalculationDrawer/config';
import { CoveragesDrawerConfig } from '../components/CoveragesDrawer/config';
import { PayeeDrawerConfig } from '../components/PayeeDrawer/config';
import { TransactionDrawerConfig } from '../components/TransactionDrawer/config';

export const drawersConfiguration: Partial<Record<Drawers, DrawerConfig>> = {
  [Drawers.ClaimSetControl]: ClaimSetControlDrawerConfig,
  [Drawers.Tasks]: TasksDrawerConfig,
  [Drawers.Documents]: DocumentsDrawerConfig,
  [Drawers.Parties]: PartiesDrawerConfig,
  [Drawers.PolicyMatching]: PolicyMatchingDrawerConfig,
  [Drawers.RecentActivity]: RecentActivityDrawerConfig,
  [Drawers.Notes]: NotesDrawerConfig,
  [Drawers.Insured]: InsuredDrawerConfig,
  [Drawers.Contacts]: ContactsDrawerConfig,
  [Drawers.Beneficiary]: BeneficiaryDrawerConfig,
  [Drawers.AdminUsers]: AdminUserControlDrawerConfig,
  [Drawers.Coverages]: CoveragesDrawerConfig,
  [Drawers.Milestones]: MilestonesDrawerConfig,
  [Drawers.BenefitCalculation]: BenefitCalculationDrawerConfig,
  [Drawers.Payee]: PayeeDrawerConfig,
  [Drawers.Transaction]: TransactionDrawerConfig,
  [Drawers.PartyControl]: PartyControlDrawerConfig,
  [Drawers.PartyAddresses]: PartyAddressesDrawerConfig,
  [Drawers.PartyPaymentInformation]: PartyPaymentInformationDrawerConfig,
  [Drawers.Producer]: ProducerDrawerConfig,
};
